<div class="batch-pending-notification">
  <div class="batch-notification-icon">
    <img class="batch-notification-icon-img" src="/assets/icons/icon_attention_md.svg" />
  </div>
  <div class="batch-pending-notification-text">
    <div class="batch-pending-notification-text-header">{{ header | translate }}</div>
    <div class="batch-pending-notification-text-hint">{{ hint | translate }}</div>
  </div>
</div>
